import { ApiDef_AdvisorSnippet, DBDef_AdvisorSnippet } from '@app/advisor-content-shared';
import { apiWithBody, ModuleFE_AppConfig, ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onAdvisorSnippetsUpdated = new ThunderDispatcherV3('__onAdvisorSnippetsUpdated');
export class ModuleFE_AdvisorSnippet_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_AdvisorSnippet, dispatch_onAdvisorSnippetsUpdated);
        this._v1 = {
            updateFHIRQueryResources: apiWithBody(ApiDef_AdvisorSnippet._v1.updateFHIRQueryResources, this.onFHIRQueryResourcesUpdated)
        };
    }
    __searchFilterMapper = (item) => [item.label];
    __searchGroups = (items, filter) => {
        return [{
                group: this.dbDef.dbKey,
                results: items.map(item => ({
                    _id: item._id,
                    uiLabel: item.label,
                }))
            }];
    };
    onFHIRQueryResourcesUpdated = async (response) => {
        await this.onEntriesUpdated(response.snippets);
        await ModuleFE_AppConfig.onEntriesUpdated([response.appConfig]);
    };
}
export const ModuleFE_AdvisorSnippet = new ModuleFE_AdvisorSnippet_Class();
//# sourceMappingURL=ModuleFE_AdvisorSnippet.js.map